import { selectMatchingVideoSource } from '../utils';
import { gsap } from 'gsap';

export default class HomeIntroVideo {
	constructor(elm) {
		if (!'ResizeObserver' in window) {
			return;
		}

		this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));

        this.elm = elm;
        this.init(this.elm);
	}

	init(elm) {

        document.dispatchEvent(new CustomEvent('disable-scroll'));

		const autoplayVideos = elm.querySelectorAll('[data-home-intro-video]');
		autoplayVideos.forEach(autoplayVideo => {
			new Video(autoplayVideo, this);

            if(autoplayVideo.offsetHeight||autoplayVideo.offsetWidth||autoplayVideo.getClientRects().length) { // Is rendered
                autoplayVideo.dispatchEvent(new CustomEvent('play-video'));
                this.resizeObserver.observe(autoplayVideo);
            }
		});
	}

	handleResize(entries) {
		entries.forEach(entry => {
			const target = entry.target;
			target.dispatchEvent(new CustomEvent('select-source'));
		});
	}

    hide() {
        document.dispatchEvent(new CustomEvent('enable-scroll'));

        gsap.to(this.elm, {
            opacity: 0,
            ease: 'none',
            duration: 1,
            onComplete: () => {
                this.destroy();
            }
        });
    }

    destroy() {
        this.elm.remove();
		this.resizeObserver.disconnect();
    }
}


class Video {
    constructor(autoplayVideo, parent) {
        this.parent = parent;
		this.elm = autoplayVideo;
        this.sourceSelected = false;
		this.video = this.elm.querySelector('video');
		if(!this.video) {
			return;
		}

		this.newTime = null;
		this.shouldPlay = false;

		this.elm.addEventListener('select-source', () => {
			this.selectSource();
		});

		this.elm.addEventListener('play-video', () => {
			this.shouldPlay = true;
            if(this.sourceSelected) {
			    this.playVideo();
            }
		});

        this.video.addEventListener('ended', () => {
			this.finishVideo();
		});

		this.video.addEventListener('loadedmetadata', () => {
			if(this.newTime) {
				this.video.currentTime = this.newTime;
				this.newTime = null;
			}
		});

    }

	playVideo() {
		let startPlayPromise = this.video.play();
		if (startPlayPromise !== undefined) {
			startPlayPromise.then(() => {
				this.elm.classList.add('is-playing');
				this.elm.classList.remove('has-error');
			}).catch((error) => {
				if(!this.elm) {
					return;
				}
                this.elm.classList.add('has-error');
                this.parent.hide();
			});
		}
	}

    finishVideo() {
        this.parent.hide();
    }

	selectSource() {
		this.oldTime = this.video.currentTime;
		selectMatchingVideoSource(this.video).then(() => {
            this.sourceSelected = true;
			this.newTime = this.oldTime;
			if(this.shouldPlay) {
				this.playVideo();
			}
		});
	}
}